import Constants from "../../Constants.js";
import Api from "./Api.js";
import Auth from "./Auth.js";
import Redux from "./Redux.js";
import ApiLoad from "./ApiLoad.js";
import LoadConfig from "./LoadConfig.js";
import { plugin as UnifiedHistory } from "./UnifiedHistory.js";
import Router from "./Router.js";
import LocalCan from "./LocalCan.js";
import MoltenProviderPlg from "./MoltenProvider.js";
const {
  INITIALIZER,
  PROVIDER,
  REDUX_REDUCER,
  REDUX_MIDDLEWARE,
  PRERENDER,
  LOGGED_IN
} = Constants;
const install = molten => {
  molten.addPlugin(PROVIDER, MoltenProviderPlg);
  molten.addPlugin(INITIALIZER, LoadConfig);
  molten.addPlugin(INITIALIZER, Api);
  molten.addPlugin(PROVIDER, Api);
  molten.addPlugin(REDUX_REDUCER, Api);
  molten.addPlugin(REDUX_MIDDLEWARE, Auth);
  molten.addPlugin(PRERENDER, Auth);
  molten.addPlugin(PROVIDER, Redux);
  molten.addPlugin(REDUX_REDUCER, Redux);
  molten.addPlugin(LOGGED_IN, ApiLoad);
  molten.addPlugin(REDUX_REDUCER, UnifiedHistory);
  molten.addPlugin(PROVIDER, Router);
  molten.addPlugin(REDUX_MIDDLEWARE, Router);
  molten.addPlugin(REDUX_REDUCER, Router);
  molten.addPlugin(INITIALIZER, LocalCan);
};
export default {
  install
};